module.exports = __webpack_public_path__ + "img/店主发红包.b6baa808.svg";